import type { SVGProps } from "react";
const SenecPictogramFindChargeStation = (props: Pick<SVGProps<SVGSVGElement>, "color">) => (
    <svg width={48} height={48} viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg" role="img" {...props}>
        <path
            d="M15 12C15 10.3431 16.3431 9 18 9H30C31.6569 9 33 10.3431 33 12V37H46V39H2V37H31V12C31 11.4477 30.5523 11 30 11H18C17.4477 11 17 11.4477 17 12V27H19.1C19.5633 24.7178 21.581 23 24 23H26V25H28V27H24V25C22.3431 25 21 26.3431 21 28C21 29.6569 22.3431 31 24 31V29H28V31H26V33H24C21.581 33 19.5633 31.2822 19.1 29H17V33C17 33.5523 16.5523 34 16 34C15.4477 34 15 33.5523 15 33V12Z"
            fill="currentColor"
        />
        <path
            d="M5.29289 11.2929C5.68342 10.9024 6.31658 10.9024 6.70711 11.2929L9.70711 14.2929C10.0976 14.6834 10.0976 15.3166 9.70711 15.7071C9.31658 16.0976 8.68342 16.0976 8.29289 15.7071L5.29289 12.7071C4.90237 12.3166 4.90237 11.6834 5.29289 11.2929Z"
            fill="currentColor"
        />
        <path
            d="M41.2929 11.2929C41.6834 10.9024 42.3166 10.9024 42.7071 11.2929C43.0976 11.6834 43.0976 12.3166 42.7071 12.7071L39.7071 15.7071C39.3166 16.0976 38.6834 16.0976 38.2929 15.7071C37.9024 15.3166 37.9024 14.6834 38.2929 14.2929L41.2929 11.2929Z"
            fill="currentColor"
        />
        <path fillRule="evenodd" clipRule="evenodd" d="M19 13H29V20H19V13ZM21 15V18H27V15H21Z" fill="currentColor" />
        <path
            d="M8.70711 19.2929L12.4142 23L8.70711 26.7071L7.29289 25.2929L8.58579 24H3C2.44772 24 2 23.5523 2 23C2 22.4477 2.44772 22 3 22H8.58579L7.29289 20.7071L8.70711 19.2929Z"
            fill="currentColor"
        />
        <path
            d="M39.4142 24L40.7071 25.2929L39.2929 26.7071L35.5858 23L39.2929 19.2929L40.7071 20.7071L39.4142 22H45C45.5523 22 46 22.4477 46 23C46 23.5523 45.5523 24 45 24H39.4142Z"
            fill="currentColor"
        />
        <path
            d="M9.70711 30.2929C10.0976 30.6834 10.0976 31.3166 9.70711 31.7071L6.70711 34.7071C6.31658 35.0976 5.68342 35.0976 5.29289 34.7071C4.90237 34.3166 4.90237 33.6834 5.29289 33.2929L8.29289 30.2929C8.68342 29.9024 9.31658 29.9024 9.70711 30.2929Z"
            fill="currentColor"
        />
        <path
            d="M38.2929 30.2929C38.6834 29.9024 39.3166 29.9024 39.7071 30.2929L42.7071 33.2929C43.0976 33.6834 43.0976 34.3166 42.7071 34.7071C42.3166 35.0976 41.6834 35.0976 41.2929 34.7071L38.2929 31.7071C37.9024 31.3166 37.9024 30.6834 38.2929 30.2929Z"
            fill="currentColor"
        />
    </svg>
);
export default SenecPictogramFindChargeStation;
